
export const solutions = {
  '1gb.solutions': 'פתרונות 1Gb',
  '10gb.solutions': 'פתרונות 10Gb',
  '1gb.vpx.accessories': 'אביזרי VPX 1Gb',
  'software': 'תוכנה',
  '1gb.description': 'פתרונות AV על גבי IP בביצועים גבוהים 1Gb',
  '10gb.description': 'פתרונות AV על גבי IP בביצועים גבוהים במיוחד 10Gb',
  'vpx.accessories.description': 'אביזרים חיוניים לפתרונות VPX 1Gb',
  'software.description': 'תוכנת Aurora IPBaseT Manager היא אפליקציית בקרה הכל-כלול עבור סדרות IPX, VPX ו-VLX של מוצרי Aurora IPBaseT AV על גבי IP',
  'avoip.solutions': 'פתרונות AVOIP',
  'choose.network.speed': 'בחר את מהירות הרשת המועדפת עליך',
  'touch.controllers': 'בקרי מגע',
  'touch.controllers.description': 'ממשקי לוח מגע מקצועיים לשליטה חלקה',
  'control.processors': 'מעבדי בקרה',
  'control.processors.description': 'מעבדי בקרה מתקדמים לניהול מערכת',
  'reax.software': 'תוכנה',
  'reax.software.description': 'תוכנת פיתוח מערכת בקרה מקצועית',
  'reax.accessories': 'אביזרים',
  'reax.accessories.description': 'אביזרים חיוניים למערכות ReAX',
  'reax.control.solutions': 'פתרונות בקרת ReAX',
  'choose.control.solution': 'בחר את פתרון הבקרה המועדף עליך',
  'digital.signal.processors': 'מעבדי אות דיגיטלי',
  'dsps.description': 'פתרונות עיבוד אודיו מקצועיים',
  'amplifiers': 'מגברים',
  'amplifiers.description': 'הגברת אודיו בביצועים גבוהים',
  'speakers': 'רמקולים',
  'speakers.description': 'פתרונות שחזור אודיו פרימיום',
  'audio.solutions': 'פתרונות אודיו',
  'choose.audio.solution': 'בחר את פתרון האודיו המועדף עליך',
};
